import type { PDFDocumentLoadingTask, PDFDocumentProxy } from 'pdfjs-dist';
import { loadPdf } from './pdfRender';

// THE PICTURES A CALL CARRIES, rendered for the panel that says what a button would send.
//
// Every phase's badge shows the words; a Gemini call in this app is mostly images, and the
// prompt alone tells you nothing about that half of the question — which page was masked,
// how much of it survived, how many pages rode along, which band a step was cut to.
//
// So each phase renders its own, from the same PDF at the same widths as the run: not an
// illustration of the call, the same pixels. These two helpers are what all of them share —
// the tile shape, and opening the document once and closing it after.
// Both lines are required here, though TipPicture has them optional: a tile with no name is
// a picture nobody can place, and every caller has one to give.
export const asPicture = (image: string, label: string, caption: string) => ({
  url: image, label, caption,
});

// Opened, used, closed. Every one of these renders a few pages out of a PDF nobody else has
// open at that moment, and a document left loaded is a worker and a buffer held for a panel
// that has been shut.
export async function withDoc<T>(
  file: Blob,
  fn: (doc: PDFDocumentProxy) => Promise<T>,
  fallback: T,
) {
  let task: PDFDocumentLoadingTask | null = null;
  try {
    task = loadPdf(await file.arrayBuffer());
    return await fn(await task.promise);
  } catch {
    return fallback;
  } finally {
    void task?.destroy();
  }
}
